//
// Action types
//

export const SELECT_ITEM = "SELECT_ITEM";
export const UNSELECT_ITEM = "UNSELECT_ITEM";

//
// Action creators
//

export function selectItem(resourcesListKey, itemId, itemType = null) {
  return {
    type: SELECT_ITEM,
    resourcesListKey,
    itemId,
    itemType
  };
}

export function unselectItem(resourcesListKey) {
  return {
    type: UNSELECT_ITEM,
    resourcesListKey
  };
}

function selectItemHandler(itemId, itemType) {
  return { itemId, itemType };
}

function unselectItemHandler() {
  return {};
}

//
// Reducer and handlers
//

export function reduceSelection(state, action) {
  switch (action && action.type) {
    case SELECT_ITEM:
      return selectItemHandler(action.itemId, action.itemType);

    case UNSELECT_ITEM:
      return unselectItemHandler();

    default:
      return state || {};
  }
}
